import { render, staticRenderFns } from "./ConfigIcon.vue?vue&type=template&id=f26e9fca&scoped=true&"
import script from "./ConfigIcon.vue?vue&type=script&lang=js&"
export * from "./ConfigIcon.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIcon.vue?vue&type=style&index=0&id=f26e9fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26e9fca",
  null
  
)

export default component.exports